import { render, staticRenderFns } from "./DetailTariff.vue?vue&type=template&id=30b7e899&"
import script from "./DetailTariff.vue?vue&type=script&lang=js&"
export * from "./DetailTariff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports